import React, { Dispatch, SetStateAction } from 'react';
import Image from 'next/legacy/image';
import redHeartIcon from '@assets/images/red-heart-icon.svg';
import closeArrowsIcon from '@assets/images/close-arrows.svg';

type Props = {
  setIsLoginButtonClicked: Dispatch<SetStateAction<boolean>>;
  setIsSignUpButtonClicked: Dispatch<SetStateAction<boolean>>;
  setShowCloseButton: Dispatch<SetStateAction<boolean>>;
};

export default function FavoritesLoginForm({
  setIsLoginButtonClicked,
  setIsSignUpButtonClicked,
  setShowCloseButton,
}: Props) {
  return (
    <div className="mx-auto max-w-6xl w-full d:flex d:flex-row d:items-start d:p-5 bg-rp-primary-sky-blue rounded-md">
      <div className="ml-2 w-10 h-10 rounded-full border-2 bg-white flex justify-center items-center">
        <Image src={redHeartIcon} alt="heart" />
      </div>
      <div className="ml-5">
        <div className="font-semibold">Sign in to save</div>
        <div>
          <button type="button" onClick={() => setIsLoginButtonClicked(true)}>
            <a className="font-rp-pn-semi-bold text-rp-primary-light underline cursor-pointer">
              Log in
            </a>
          </button>{' '}
          or{' '}
          <button type="button" onClick={() => setIsSignUpButtonClicked(true)}>
            <a className="font-rp-pn-semi-bold text-rp-primary-light underline cursor-pointer">
              Sign up
            </a>
          </button>{' '}
          to sync your saved hotels to any device.
        </div>
      </div>
      <button type="button" onClick={() => setShowCloseButton(false)} className="ml-auto">
        <Image src={closeArrowsIcon} alt="close-icon" />
      </button>
    </div>
  );
}
